import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { Button } from "src/components/generic";

interface ICheckoutFormProps { 
  setHasPaidDeposit: Dispatch<SetStateAction<boolean>>;
  formattedAmount: string;
}

const CheckoutForm: FunctionComponent<ICheckoutFormProps> = ({ setHasPaidDeposit, formattedAmount }) => {
  const stripe = useStripe();
  const elements = useElements();

  const submitPayment = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) return;

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });

    if (error) {
      console.error(error.message);
    } else if (paymentIntent?.status === "succeeded") {
      setHasPaidDeposit(true);
    }
  };

  return (
    <div className="flex justify-between w-full">
      <div className="w-[45%]">
        <PaymentElement id="payment-element" options={{ layout: 'accordion' }} />
      </div>
      
      <div className="ml-6">
        
      <div className="bg-gradient-to-br from-primary/90 to-primary/50 text-white p-8 rounded-2xl shadow-xl border border-white/10 backdrop-blur-md space-y-6 animate-fadeIn">
        <div className="space-y-2">
          <h3 className="text-2xl font-semibold tracking-wide text-white">Non-Refundable Deposit</h3>
          <p className="text-white/80 leading-relaxed">
            Upon receipt of deposit, and completion of account registration a soft credit pull will be initiated.
          </p>
          <p className="text-white/70 text-sm">
            By submitting a deposit, you accept <span className="text-secondary-light hover:text-white transition-colors cursor-pointer">ClientVitals' Terms & Agreements</span> and <span className="text-secondary-light hover:text-white transition-colors cursor-pointer">Privacy Policy</span>.
          </p>
        </div>

        <div className="border-t border-white/10 pt-4 space-y-2">
          <p className="font-semibold text-lg text-secondary-light">Pre-Qualification Intake & Assessment Deposit</p>
          <p className="text-white/90">Subtotal: <span className="font-medium">{formattedAmount}</span></p>
          <p className="text-white/90">Total: <span className="font-medium">{formattedAmount}</span></p>
        </div>

        <div className="pt-4">
          <Button
            text="Confirm Payment"
            styles="w-[220px] h-[55px] text-lg tracking-wide font-semibold bg-secondary hover:bg-primary transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_15px_rgba(255,255,255,0.4)]"
            onClick={submitPayment}
          />
        </div>
      </div>

      </div>
    </div>
  );
};

export default CheckoutForm;